export default __webpack_public_path__ + "static/media/two.fd7b365f.png";